export default __webpack_public_path__ + "static/media/feature4_6.aadee67d.png";